import React from 'react';
import { OrdemDeServicoCompleta } from '../../types/ordemServico';
import { PenTool, Shield, Globe } from 'lucide-react';

interface OsAssinaturaSectionProps {
  os: OrdemDeServicoCompleta;
}

export const OsAssinaturaSection: React.FC<OsAssinaturaSectionProps> = ({ os }) => {
  return (
    <div className="space-y-4 pt-4 border-t border-slate-200">
      <div className="flex items-center gap-2 border-b border-slate-100 pb-2">
        <PenTool className="w-4 h-4 text-red-600" />
        <h3 className="text-sm font-bold uppercase tracking-wider text-slate-700">Assinatura do Cliente</h3>
      </div>

      <div className="bg-slate-50 border border-slate-200/80 rounded-xl p-4 space-y-4">
        {/* Assinatura Visual */}
        <div>
          <span className="text-xs text-slate-400 font-semibold block uppercase mb-2">Assinatura Registrada</span>
          {os.assinatura ? (
            <div className="bg-white border border-slate-200 rounded-lg p-2 max-w-md mx-auto flex items-center justify-center min-h-[120px]">
              <img
                src={os.assinatura}
                alt="Assinatura Digital"
                className="max-h-36 object-contain"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
            </div>
          ) : (
            <div className="bg-white border border-dashed border-slate-300 rounded-lg p-6 text-center text-xs text-slate-400">
              Nenhuma assinatura gravada nesta O.S.
            </div>
          )}
        </div>

        {/* Metadados da Assinatura (RG e IP) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2 border-t border-slate-200/60">
          <div className="flex items-center gap-2">
            <Shield className="w-4 h-4 text-slate-400" />
            <div>
              <span className="text-xs text-slate-400 font-semibold block uppercase">RG da Assinatura</span>
              <span className="text-xs font-bold text-slate-800">{os.rg_assinatura || 'Não informado'}</span>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <Globe className="w-4 h-4 text-slate-400" />
            <div>
              <span className="text-xs text-slate-400 font-semibold block uppercase">IP de Origem</span>
              <span className="text-xs font-bold text-slate-800 font-mono">{os.ip_assinatura || 'Não registrado'}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
